import React, { useEffect, useState } from 'react';
import { PROJECT_OPTIONS_INPUT, TYPE_UPLOAD } from '@src/constants/upload';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { removeEmptyLineOfText } from '@src/services/tts';
import { INPUT_TTS_TYPE } from '@src/constants/tts';
import UploadFile from '@src/containers/TTS/UploadFile';
import ImportURL from '@src/containers/TTS/NewImportURL';
import { splitParagraphIntoSentence } from '@src/services/sentence';
import ProjectInputItem from './ProjectInputItem';
import { StyledProjectInput } from './index.style';

const ProjecInput = () => {
  const [openUpload, setOpenUpload] = useState(false);
  const [openImportUrl, setOpenImportUrl] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();

  const handleOpenUpload = () => setOpenUpload(true);
  const handleCloseUpload = () => setOpenUpload(false);

  const handleOpenImportUrl = () => setOpenImportUrl(true);
  const handleCloseImportUrl = () => setOpenImportUrl(false);

  const handleUploadContent = (text) => {
    const handledText = removeEmptyLineOfText(text);
    // eslint-disable-next-line no-unused-vars
    const paragraphs = splitParagraphIntoSentence(handledText);
  };

  const handleSelectOptionInput = (name, item) => {
    switch (item.type) {
      case TYPE_UPLOAD.LINK:
        handleOpenImportUrl();
        break;
      case TYPE_UPLOAD.FILE:
        handleOpenUpload();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const inputType = queryParams.get('inputType');
    switch (inputType) {
      case INPUT_TTS_TYPE.FILE:
        setOpenUpload(true);
        break;
      case INPUT_TTS_TYPE.LINK:
        setOpenImportUrl(true);
        break;
      default:
        break;
    }
  }, [location]);

  return (
    <StyledProjectInput>
      {PROJECT_OPTIONS_INPUT.map((option) => (
        <ProjectInputItem
          key={option.title}
          logo={option.icon}
          title={t(option.label)}
          option={option}
          onSelect={handleSelectOptionInput}
        />
      ))}
      <UploadFile
        open={openUpload}
        onClose={handleCloseUpload}
        onHandleUploadContent={handleUploadContent}
      />
      <ImportURL
        open={openImportUrl}
        onClose={handleCloseImportUrl}
        onHandleUploadContent={handleUploadContent}
      />
    </StyledProjectInput>
  );
};

export default ProjecInput;
